import type { UnitRole } from "../sim/types";
import { portalFfaCatalog } from "../../../data/portal-ffa-catalog";

/** Soft cap on simultaneous corpse views — oldest purged first when exceeded. */
export const DYING_VIEW_BUDGET = 32;

export function deathTtlSec(role: UnitRole): number {
  const fx = portalFfaCatalog.fx as {
    deathMs?: number;
    masterDeathMs?: number;
  };
  const ms =
    role === "master"
      ? Number(fx.masterDeathMs) || 420
      : Number(fx.deathMs) || 280;
  return Math.max(0.08, ms / 1000);
}

/** Whether a dying presentation view should be destroyed this frame. */
export function shouldPurgeDyingView(
  animTime: number,
  clipDone: boolean,
  ttlSec: number,
): boolean {
  if (clipDone) return true;
  return animTime >= ttlSec;
}

/**
 * Pick dying view ids to force-purge when over budget (oldest animTime first).
 * `entries` = [id, animTime] for currently dying views after normal TTL purge.
 */
export function dyingIdsOverBudget(
  entries: Array<{ id: number; animTime: number }>,
  budget = DYING_VIEW_BUDGET,
): number[] {
  if (entries.length <= budget) return [];
  const sorted = entries.slice().sort((a, b) => b.animTime - a.animTime);
  const excess = sorted.length - budget;
  return sorted.slice(0, excess).map((e) => e.id);
}
